import { useEffect } from 'react'

window.nachnamen = window.nachnamen || {}
// const url =
//   'interaktiv-mf.tagesanzeiger.ch/2026/etl-nachnamen/allnames.json?a=' +
//   Math.random()
const url = 'https://interaktiv.tagesanzeiger.ch/2025/nachnamen/allnames.json?a='+Math.random()
export const LoadAllNames = () => {
  useEffect(() => {
    if (window.nachnamen.allnames) return
    fetch(url)
      .then(d => d.json())
      .then(d => {
        var preped: { name: string; count: number; rank: number }[] = []
        d.map((e: { count: number; names: string; rank: number }) => {
          var group = prepNameGroup(e)
          preped = preped.concat(group)
        })

        window.nachnamen.allnames = preped.sort((a, b) => a.rank - b.rank)
        const event = new Event('allnames_loaded')
        window.dispatchEvent(event)
      })
  }, [])
  return null
}

const names_to_ignore = ['Arularakilan']

function prepNameGroup ({
  names,
  count,
  rank
}: {
  count: number
  names: string
  rank: number
}) {
  names_to_ignore.map(m => {
    names = names.replace(m, '')
  })
  return [{ name: names, count: count, rank }]
}
